import { render, staticRenderFns } from "./TreatmentPlan.vue?vue&type=template&id=525089ad"
import script from "./TreatmentPlan.vue?vue&type=script&lang=js"
export * from "./TreatmentPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports